export default __webpack_public_path__ + "static/media/searchError.9c3b9fe1.svg";